import * as DTO from '@rw1/auto-generated-clients/generated/user-management/dto.generated'
import { injectable } from 'inversify'
import * as Models from '@rw1/models'
import { IUserManagementMapper } from './IUserManagementMapper'

@injectable()
export class UserManagementMapper implements IUserManagementMapper {

    toResetPasswordRequest(email: string): DTO.IResetPasswordRequest {
        return {
            userIdentifier: email,
            isV2: true,
        }
    }

    toUser(dto: DTO.UserWithCompanyName): Models.User {
        return {
            userId: dto.userId,
            companyId: dto.companyId,
            profilePictureUrl: dto.profilePictureUrl ?? '',
            forename: dto.forename,
            surname: dto.surname,
            emailAddress: dto.emailAddress,
            username: dto.username ?? '',
            jobTitle: dto.jobTitle ?? '',
            userRole: dto.role,
            country: dto.country,
            companyName: dto.companyName,
            status: Models.UserAvailabilityStatus.Offline,
        }
    }

    toVisibility(dto: DTO.SessionType | null | undefined): Models.Visibility {
        if (!dto) {
            return Models.Visibility.Private
        }
        switch (dto) {
            case DTO.SessionType.Public:
                return Models.Visibility.Public
            case DTO.SessionType.Internal:
                return Models.Visibility.Internal
            case DTO.SessionType.Private:
                return Models.Visibility.Private
            default:
                throw new Error(`Unknown visibility type: ${dto}`)
        }
    }

    toUserSettingsModel(dto: DTO.UserSetting[]): Map<string, string> {
        const map = new Map<string, string>();
        dto.forEach((setting) => {
            map.set(setting.settingKey, setting.settingValue);
        });

        return map;
    }
}